import { HttpContextToken } from '@angular/common/http';

export const DO_NOTIFY_SUCCESS = new HttpContextToken<false | string>(() => false);
